import { render, staticRenderFns } from "./Play.vue?vue&type=template&id=a7ecfde8&"
import script from "./Play.vue?vue&type=script&lang=js&"
export * from "./Play.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports